
import React from 'react';
import RegisterForm from '../components/Auth/RegisterForm';

const Register: React.FC = () => {
  return <RegisterForm />;
};

export default Register;
